const translations = {
  "en": {
    " applied": " applied",
    " not applied": " not applied",
    "Add a referral code": "Add a referral code",
    "Apply code": "Apply code",
    "Back": "Back",
    "e.g. LXmWwn": "e.g. LXmWwn",
    "Enter the code a friend shared with you.": "Enter the code a friend shared with you.",
    "Have a referral code?": "Have a referral code?",
    "Referral code ": "Referral code ",
    "We don't recognise that code. Check it and try again.": "We don't recognise that code. Check it and try again."
  },
  "zh-tw": {
    " applied": "已套用",
    " not applied": "未套用",
    "Add a referral code": "新增推薦碼",
    "Apply code": "套用優惠碼",
    "Back": "返回",
    "e.g. LXmWwn": "例如 LXmWwn",
    "Enter the code a friend shared with you.": "輸入朋友分享給你的代碼。",
    "Have a referral code?": "有推薦碼嗎？",
    "Referral code ": "推薦碼",
    "We don't recognise that code. Check it and try again.": "無法辨識該代碼。請檢查後重試。"
  }
};

export default translations;
